import React, { useEffect, useState } from 'react';
import axios from 'axios';

import CalenderLinks from '../../../components/CalanderLinks/CalanderLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';

import './Diwali.scss';

const Diwali = () => {
  const [diwaliData, setDiwaliData] = useState([]);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [tempYear, setTempYear] = useState(currentYear);

  // ----- NEW: Modal state -----
  const [selectedEvent, setSelectedEvent] = useState(null); // selected event name
  const [isModalOpen, setIsModalOpen] = useState(false); // modal open/close
  const [selectedFestivalDetail, setSelectedFestivalDetail] = useState(null);


  // ----- NEW: Functions for modal -----
  const openModal = (eventName) => {
    setSelectedEvent(eventName);
    setIsModalOpen(true);
  };
 const openDetailPage = (eventName, item) => {
  setSelectedFestivalDetail({
    name: eventName,
    date: item.date,
    weekday: item.weekday,
    tithi: item.tithi,
    theme: item.theme,
    description: popups[eventName]
  });
};



  const closeModal = () => {
    setSelectedEvent(null);
    setIsModalOpen(false);
  };
  // ----- END NEW -----

  const deepawaliFestivalTooltips = {
    "Govatsa Dwadashi": "Govatsa Dwadashi is observed by worshipping cows and calves, symbolizing reverence toward Nandi, the sacred bull of Lord Shiva.",
    "Vasu Baras": "Vasu Baras is celebrated in Maharashtra to honor cows and express gratitude for their contributions to agriculture and daily life.",
    "Dhantrayodashi": "Dhantrayodashi, also known as Dhanvantari Trayodashi, marks the appearance of Lord Dhanvantari, the deity of Ayurveda and health.",
    "Dhanteras": "Dhanteras is the first day of Diwali, associated with purchasing gold, silver, or utensils as a sign of prosperity and good fortune.",
    "Dhanvantari Trayodashi": "Dhanvantari Trayodashi celebrates the divine physician Dhanvantari, who emerged with the nectar of immortality during the churning of the ocean.",
    "Yama Deepam": "Yama Deepam is a ritual where lamps are lit in the evening to ward off untimely death and honor Lord Yama, the god of death.",
    "Kali Chaudas": "Kali Chaudas is observed a day before Diwali in Gujarat and some western states, focusing on removing evil influences and negativity.",
    "Hanuman Puja": "Hanuman Puja on this day is believed to ward off fear and negative energies. Devotees pray to Lord Hanuman for strength and protection.",
    "Narak Chaturdashi": "Narak Chaturdashi commemorates Lord Krishna’s victory over the demon Narakasura. It symbolizes the removal of darkness and ignorance.",
    "Tamil Deepavali": "Tamil Deepavali is celebrated in Tamil Nadu with early morning oil baths, sweets, and bursting crackers, marking the victory of good over evil.",
    "Kali Puja": "Kali Puja, especially in Bengal, is dedicated to Goddess Kali. Devotees perform midnight worships and rituals to seek her blessings.",
    "Lakshmi Puja": "Lakshmi Puja is the main Diwali day where Goddess Lakshmi, the deity of wealth and prosperity, is worshipped in homes and businesses.",
    "Diwali": "Diwali, the festival of lights, celebrates the return of Lord Rama to Ayodhya. Homes are lit with diyas and decorated with rangolis.",
    "Kedar Gauri Vrat": "Kedar Gauri Vrat is observed for marital bliss and spiritual growth, primarily by women in some regions of India.",
    "Chopda Puja": "Chopda Puja is performed by businessmen to start new accounting books, invoking blessings of Lord Ganesha and Goddess Lakshmi.",
    "Sharda Puja": "Sharda Puja is dedicated to Goddess Saraswati, the goddess of wisdom and learning, especially celebrated in Gujarat.",
    "Diwali Snan": "Diwali Snan refers to ritualistic oil baths taken before sunrise, believed to cleanse the body and spirit.",
    "Diwali Devpuja": "Diwali Devpuja involves worship of deities at home, seeking peace, prosperity, and divine blessings.",
    "Govardhan Puja": "Govardhan Puja commemorates Lord Krishna lifting the Govardhan Hill to protect villagers from torrential rain.",
    "Annakut": "Annakut, meaning 'mountain of food', involves offering hundreds of food items to Lord Krishna in gratitude.",
    "Bali Pratipada": "Bali Pratipada marks the return of King Bali to Earth, symbolizing the triumph of devotion and humility.",
    "Dyuta Krida": "Dyuta Krida commemorates the divine game of dice between Lord Shiva and Parvati, symbolizing fate and playfulness.",
    "Gujarati New Year": "Gujarati New Year begins the next day after Diwali and is celebrated with prayers, new ledgers, and sweets.",
    "Bhaiya Dooj": "Bhaiya Dooj is a festival celebrating the bond between brothers and sisters, with rituals and blessings exchanged.",
    "Bhau Beej": "Bhau Beej is celebrated in Maharashtra similar to Raksha Bandhan, where sisters pray for their brothers’ well-being.",
    "Yama Dwitiya": "Yama Dwitiya marks the meeting of Yama and his sister Yamuna. Brothers visit sisters who perform aarti and apply tilak.",
    "Chitragupta Puja": "Chitragupta Puja is performed by the Kayastha community to worship Lord Chitragupta, the divine accountant who keeps karma records."
  };


  const popups = {
  "Dhanvantari Trayodashi": "Dhanvantari Trayodashi celebrates the divine physician Dhanvantari, who emerged with the nectar of immortality during the churning of the ocean.",
  "Govatsa Dwadashi": "Govatsa Dwadashi is celebrated mainly in Maharashtra and Karnataka. On this day, cows and calves are worshipped, as they are considered sacred and a source of nourishment. Devotees perform rituals, decorate cows, and offer grass, flowers, and sweets. The festival signifies gratitude towards cattle for their contribution to agriculture and human life.",
  "Vasu Baras": "Vasu Baras marks the beginning of Diwali festivities in Maharashtra. Farmers and families honor cows and bulls, offer prayers for prosperity, and perform special rituals. Traditionally, gold, silver, and grains are worshipped, symbolizing abundance, health, and protection from diseases.",
  "Dhantrayodashi": "Also known as Dhanvantari Trayodashi, this day is associated with Lord Dhanvantari, the divine physician who appeared during Samudra Manthan with the nectar of immortality. Devotees pray for good health, prosperity, and protection from illnesses, often performing rituals in temples or at home.",
  "Dhanteras": "Dhanteras marks the first day of Diwali and is considered highly auspicious for buying precious metals like gold, silver, or utensils. People clean their homes, light lamps, and pray to Goddess Lakshmi and Lord Dhanvantari. It symbolizes wealth, health, and prosperity for the coming year.",
  "Yama Deepam": "Yama Deepam is observed in the evening by lighting oil lamps at homes to honor Lord Yama, the god of death. The ritual is believed to protect family members from untimely death and bring long life and well-being. People also perform prayers for ancestors to seek blessings and peace for departed souls.",
  "Kali Chaudas": "Kali Chaudas, or Naraka Chaturdashi in some regions, is observed a day before Diwali. Devotees focus on removing negative energies and evil influences. Special rituals and prayers are performed, lamps are lit, and homes are cleaned. In some areas, people burst firecrackers symbolizing victory over darkness.",
  "Hanuman Puja": "On this day, devotees worship Lord Hanuman to ward off fear, protect against evil, and gain courage and strength. Special chants, offerings, and rituals are performed, and people read Hanuman Chalisa. It is believed that this puja enhances devotion, removes obstacles, and brings peace and prosperity.",
  "Narak Chaturdashi": "This festival commemorates Lord Krishna's victory over the demon Narakasura. People wake up early, take ritualistic oil baths, and decorate their homes with lamps. It symbolizes the triumph of good over evil, cleansing of sins, and removal of darkness and ignorance from one’s life.",
  "Tamil Deepavali": "Celebrated predominantly in Tamil Nadu, Tamil Deepavali begins with early morning oil baths, prayers, and lighting of lamps. Families prepare special sweets, exchange gifts, and burst crackers. It marks Lord Krishna's victory over evil and the prosperity and happiness of families and communities.",
  "Kali Puja": "Kali Puja is celebrated mainly in Bengal and eastern India, coinciding with Diwali. Devotees worship Goddess Kali at midnight, offering flowers, sweets, and sometimes animal sacrifices in traditional practices. It is believed that worshipping Kali brings strength, protection, and spiritual purification.",
  "Lakshmi Puja": "Lakshmi Puja is the main day of Diwali, dedicated to Goddess Lakshmi, the goddess of wealth and prosperity. People clean and decorate homes, light rows of diyas, and perform elaborate rituals. Businesses also close new accounts and pray for success. It is a day for family gatherings, prayers, and spreading joy.",
  "Diwali": "Diwali, the festival of lights, celebrates the return of Lord Rama to Ayodhya after defeating Ravana. Homes are illuminated with lamps, rangoli designs are made, and families exchange sweets and gifts. The festival represents the victory of light over darkness, knowledge over ignorance, and good over evil.",
  "Kedar Gauri Vrat": "Observed mainly by women, Kedar Gauri Vrat is dedicated to Goddess Gauri and Lord Shiva. Devotees pray for marital bliss, family harmony, and spiritual growth. Rituals involve fasting, performing prayers, and decorating idols of the deities with flowers and ornaments.",
  "Chopda Puja": "Chopda Puja is celebrated by businessmen and traders to inaugurate new accounting books. The ritual involves worshipping Goddess Lakshmi and Lord Ganesha, offering sweets, coins, and prayers for wealth and success. It is an auspicious beginning for financial activities in the coming year.",
  "Sharda Puja": "Sharda Puja is dedicated to Goddess Saraswati, the goddess of wisdom, learning, and knowledge. Devotees, especially students, worship books, pens, and musical instruments. The festival encourages intellectual growth, education, and the pursuit of learning and creativity.",
  "Diwali Snan": "Diwali Snan is a ritualistic early morning bath taken before sunrise. It is believed to purify the body and soul, remove negative energies, and prepare individuals for the festivities. People use oil, turmeric, and other natural ingredients during the ritual bath.",
  "Diwali Devpuja": "This involves offering prayers to multiple deities at home for peace, prosperity, and protection. Families perform rituals, chant mantras, and light lamps. Devpuja strengthens spiritual devotion and family bonds, ensuring harmony and blessings for the household.",
  "Govardhan Puja": "Govardhan Puja commemorates Lord Krishna lifting the Govardhan Hill to protect villagers from torrential rains and floods. Devotees build small mounds of cow dung or food, decorate them, and offer prayers. It symbolizes protection, gratitude, and reverence for nature.",
  "Annakut": "Annakut, meaning 'mountain of food', involves preparing and offering hundreds of different dishes to Lord Krishna as a mark of gratitude. The festival emphasizes abundance, generosity, and devotion. Devotees sing devotional songs and distribute prasad to family and community members.",
  "Bali Pratipada": "Bali Pratipada celebrates the return of King Bali to Earth. Devotees pray for prosperity, humility, and devotion. Special rituals include offering sweets, performing pujas, and lighting lamps. It represents the victory of devotion and righteousness over ego and pride.",
  "Dyuta Krida": "Dyuta Krida commemorates the divine dice game between Lord Shiva and Parvati. The game symbolizes fate, chance, and playful aspects of life. Devotees engage in symbolic rituals and storytelling to honor the playful yet moral lessons conveyed by the gods.",
  "Gujarati New Year": "The Gujarati New Year follows Diwali and marks the beginning of the new business and financial year. People visit temples, exchange greetings, and perform pujas for prosperity. It is a time for family gatherings, feasting, and cultural celebrations, starting the year with positivity.",
  "Bhaiya Dooj": "Bhaiya Dooj celebrates the bond between brothers and sisters. Sisters pray for their brothers’ well-being and apply tilak on their foreheads. Brothers give gifts in return. The festival strengthens sibling relationships and emphasizes family love, respect, and care.",
  "Bhau Beej": "Similar to Bhaiya Dooj, Bhau Beej is celebrated mainly in Maharashtra. Sisters perform rituals, apply tilak, and offer prayers for their brothers’ long life and happiness. Brothers bless their sisters in return. It highlights familial affection and cultural traditions.",
  "Yama Dwitiya": "Yama Dwitiya marks the meeting of Lord Yama with his sister Yamuna. Sisters perform aarti and pray for their brothers’ health and longevity. Brothers, in return, bless their sisters. The festival emphasizes the importance of sibling relationships, devotion, and family bonding.",
  "Chitragupta Puja": "Chitragupta Puja is performed by the Kayastha community to honor Lord Chitragupta, who keeps records of human deeds. People worship accounting books, perform rituals, and pray for accurate karma and blessings. The festival encourages honesty, diligence, and spiritual responsibility."
};


  useEffect(() => {
    const fetchDiwaliData = async () => {
      try {
        const response = await axios.get(`https://core-c343.onrender.com/api/dewali?year=${year}`);
        setDiwaliData(response.data.months || []);
      } catch (error) {
        console.error("Failed to fetch Diwali data:", error);
      }
    };

    fetchDiwaliData();
  }, [year]);

  const handleSubmit = () => {
    setYear(tempYear);
  };
  // ================== DETAIL PAGE ==================
// ================== DETAIL PAGE ==================
if (selectedFestivalDetail) {
  return (
    <div className="Diwali-container">
      <InnerNav />

      <div className="Diwali-content">
        <button
          className="back-btn"
          onClick={() => setSelectedFestivalDetail(null)}
        >
          ← Back
        </button>

        <h1 className="s-heading">{selectedFestivalDetail.name}</h1>

        <p><strong>Date:</strong> {selectedFestivalDetail.date}</p>
        <p><strong>Weekday:</strong> {selectedFestivalDetail.weekday}</p>
        <p><strong>Tithi:</strong> {selectedFestivalDetail.tithi}</p>
        <p><strong>Theme:</strong> {selectedFestivalDetail.theme}</p>

        <p style={{ marginTop: '20px', lineHeight: '1.6' }}>
          {selectedFestivalDetail.description || 'Description not available.'}
        </p>
      </div>

      <Footer />
    </div>
  );
}



  return (
    <div className="Diwali-container">
      <InnerNav />
      <div className="Diwali-content">
        <div className="year-selector">
          <label htmlFor="year">Select Year: </label>
          <input
            id="year"
            type="number"
            min="1900"
            max="2100"
            value={tempYear}
            onChange={(e) => setTempYear(Number(e.target.value))}
          />
          <button className="submit" onClick={handleSubmit}>Submit</button>
        </div>

        <h1 className="s-heading">{year} Diwali</h1>

        {diwaliData.map((item, index) => (
          <div className="Diwali-card" key={index}>
            <div className="card-header">
              {item.dayLabel}
            </div>

            <div className="card-body">
              <div className="s-right-section">
                <div className="s-badge">{item.dayCount}</div>
                <img src="https://img.freepik.com/free-vector/gradient-background-diwali-festival-celebration_52683-142488.jpg" alt="Diwali Icon" />
              </div>

              <div className="s-details">
                <div className="s-theme"><strong>Theme:</strong> {item.theme}</div>
                <div className="s-tithi"><strong>Tithi:</strong> {item.tithi}</div>

                {/* ----- UPDATED: clickable festival events ----- */}
                <ul className="s-festivals">
                  {item.festivals.map((fest, idx) => (
                    <li key={idx} className="tooltip-wrapper">
                      <span
                        className="event-text clickable" // NEW: added clickable class
                        style={{ cursor: 'pointer', textDecoration: 'underline #da1c1cff', color: '#b31414ff' }}
                        // onClick={() => openModal(fest)} // NEW: open modal on click
                        onClick={() => openDetailPage(fest, item)}


                      >
                        Event: {fest}
                      </span>
                      {/* {deepawaliFestivalTooltips[fest] && (
                        <span className="tooltip">{deepawaliFestivalTooltips[fest]}</span>
                      )} */}
                    </li>
                  ))}
                </ul>
                {/* ----- END UPDATED ----- */}

                <div className="s-note">
                  {item.panchangNote}
                </div>
              </div>

              <div className="date-box">
                <div className="date">{item.date.split(' ')[0]}</div>
                <div className="month-year">{item.date.split(' ').slice(1).join(' ')}</div>
                <div className="weekday">{item.weekday}</div>
              </div>
            </div>
          </div>
        ))}

        <CalenderLinks />
      </div>
      <Footer />

      {/* ----- NEW: Modal for event details ----- */}
      {isModalOpen && selectedEvent && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedEvent}</h2>
            <p>{popups[selectedEvent]}</p>
            <button className="close-btn" onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
      {/* ----- END NEW ----- */}
    </div>
  );
};

export default Diwali;
